export const books=[
  {
    id:1,
    image:"https://images-na.ssl-images-amazon.com/images/I/51PJyvcfPGL._SX321_BO1,204,203,200_.jpg" ,
    discription:"Life's Amazing Secrets: How to Find Balance and Purpose in Your Life | Inspirational Zen book on motivation, self-development & healthy living",
    author:"by Gaur Gopal Das(Author)"
  },
  {
    id:2,
    image:"https://images-na.ssl-images-amazon.com/images/I/51T8OXMiB5L._SX356_BO1,204,203,200_.jpg" ,
    discription:"Ikigai: The Japanese secret to a long and happy life",
    author:"by Héctor García(Author)"
  },
  {
    id:3,
    image: "https://images-na.ssl-images-amazon.com/images/I/51u8ZRDCVoL._SX330_BO1,204,203,200_.jpg" ,
    discription:"Rich Dad Poor Dad: What the Rich Teach Their Kids About Money That the Poor and Middle Class Do Not!",
    author:"Robert T. Kiyosaki(Author)"
  },
  {
    id:4,
    image: "https://images-na.ssl-images-amazon.com/images/I/41yu2qXhXXL._SX324_BO1,204,203,200_.jpg" ,
    discription:"Sapiens: A Brief History of Humankind",
    author:"Yuval Noah Harari(Author)"
  },
  {
    id:5,
    image: "https://images-na.ssl-images-amazon.com/images/I/51oHUvYzbsL._SX327_BO1,204,203,200_.jpg" ,
    discription:"The Theory of Everything: The Origin and Fate of the Universe",
    author:"Stephen Hawking(Author)"
  },
  {
    id:6,
    image: "https://images-na.ssl-images-amazon.com/images/I/41gVhoPaE5L._SX323_BO1,204,203,200_.jpg" ,
    discription:"Think Like a Monk: The secret of how to harness the power of positivity and be happy now ",
    author:"Jay Shetty(Author)"
  },
  {
    id:7,
    image: "https://images-na.ssl-images-amazon.com/images/I/51S7KOWir7L._SX526_BO1,204,203,200_.jpg" ,
    discription:"Atomic Habits: The life-changing million copy bestseller",
    author:"James Clear(Author)"
  },
  {
    id:8,
    image: "https://images-na.ssl-images-amazon.com/images/I/41r6F2LRf8L._SX323_BO1,204,203,200_.jpg" ,
    discription:"The Psychology of Money",
    author:"Morgan Housel(Author)"
  }
  ,
  {
    id:9,
    image: "https://images-na.ssl-images-amazon.com/images/I/51wbVQTpTgL._SX339_BO1,204,203,200_.jpg" ,
    discription:"Wings of Fire: An Autobiography of Abdul Kalam",
    author:"A. P. J. Abdul Kalam(Author)"
  }
  ,
  {
    id:10,
    image: "https://images-na.ssl-images-amazon.com/images/I/51Ss3bFMA4L._SX320_BO1,204,203,200_.jpg" ,
    discription:"The Ultimate Family Business Survival Guide",
    author:"Priyanka Gupta Zielinski(Author)"
  }
  ,
  {
    id:11,
    image: "https://images-na.ssl-images-amazon.com/images/I/41+eK8zBwQL._SX319_BO1,204,203,200_.jpg" ,
    discription:"Think and Grow Rich",
    author:"Napoleon Hill(Author)"
  }
  ,
  {
    id:12,
    image: "https://images-na.ssl-images-amazon.com/images/I/516pmXNNmCL._SX324_BO1,204,203,200_.jpg" ,
    discription:"The Subtle Art of Not Giving a F*ck: A Counterintuitive Approach to Living a Good Life",
    author:"Mark Manson(Author)"
  }
  ,
  {
    id:13,
    image: "https://images-na.ssl-images-amazon.com/images/I/51UDJ6EbhXL._SX323_BO1,204,203,200_.jpg" ,
    discription:"Harry Potter and the Philosopher's Stone",
    author:"J.K. Rowling(Author)"
  }
  ,
  {
    id:14,
    image: "https://images-eu.ssl-images-amazon.com/images/I/413OgI8KzuL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg" ,
    discription:"You Only Live Once: One for Passion Two for Love Three for Friendship",
    author:"Stuti Changle(Author) "
  },
  {
    id:15,
    image: "https://images-na.ssl-images-amazon.com/images/I/51kBS7Szd4L._SX324_BO1,204,203,200_.jpg" ,
    discription:"The Courage To Be Disliked: How to free yourself, change your life and achieve real happiness (Courage To series)",
    author:"by Fumitake Koga(Author) "
  },
  {
    id:16,
    image: "https://images-eu.ssl-images-amazon.com/images/I/51QnuLIY2uL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg" ,
    discription:"The Power of Your Subconscious Mind",
    author:"by Joseph Murphy(Author) "
  },
  {
    id:17,
    image: "https://images-na.ssl-images-amazon.com/images/I/41wUhAXrenL._SX310_BO1,204,203,200_.jpg" ,
    discription:"Think and Grow Rich",
    author:"by Napoleon Hill (Author) "
  },
  {
    id:18,
    image: "https://images-na.ssl-images-amazon.com/images/I/41+grDTP2FL._SY344_BO1,204,203,200_.jpg" ,
    discription:"DO EPIC SHIT ",
    author:"by Ankur Warikoo (Author)"
  },
  {
    id:19,
    image: "https://images-na.ssl-images-amazon.com/images/I/31bDtgec8NL._SX324_BO1,204,203,200_.jpg" ,
    discription:"The Almanack Of Naval Ravikant: A Guide to Wealth and Happiness",
    author:"by Eric Jorgenson (Author) "
  },
  {
    id:20,
    image: "https://images-na.ssl-images-amazon.com/images/I/410llGwMZGL._SX328_BO1,204,203,200_.jpg" ,
    discription:"The Alchemist ",
    author:"by Paulo Coelho (Author) "
  }
];
